<div  class="flex-row gap-none" 
      fixedScroll
      (heightChange)="updateHeight($event)"
      [otherElements]="otherElements"
      [baseElement]="baseElement"
>
  <ss-pdf-thumbnail-viewports-container class="thumbnail-container"></ss-pdf-thumbnail-viewports-container>
  
  <div class="flex-1 full-height background-lightgray-transparent">
    <ss-pdf-document-viewports-container></ss-pdf-document-viewports-container>
  </div>

  
  <ss-actor-card-collection class="actor-card-collection col-width full-height overflow-auto"></ss-actor-card-collection>
  
</div>

<ng-template  #dragTemplate 
              let-pageIdx="pageIdx" 
              let-pdfDocument="pdfDocument" 
              let-height="height"
>
  <div class="pdf-drag-overlay position-top-left"  
      [ngStyle]="{
          width: '100%',
        left: '0rem',
        height: (heightObs | async)+'px'
      }"
         
        >


    <div *ngIf="showSignaturesSubject | async" 
          class="full-stretch position-relative"
    >
      <ss-signature   *ngFor="let signature of signaturesObs | async;trackBy:trackSignatureById" 
                      [signature]="signature"
                      (positionSubject)="positionChanged($event,signature)"
      >
      </ss-signature>
    </div>
    
  </div>
</ng-template>